import React, { useEffect, useRef, useState } from 'react';

/**
 * See https://developers.google.com/maps/documentation/javascript/reference/directions?hl=en#DirectionsRenderer
 * for reference on what options are available to the DirectionsRenderer class
 *
 */
export default function DirectionsRenderer(options) {
    const [renderer, setRenderer] = useState();
    const lastAppliedRef = useRef({});

    useEffect(() => {
        if (!renderer) {
            setRenderer(
                new window.google.maps.DirectionsRenderer({
                    preserveViewport: true,
                })
            );
        }

        return () => {
            if (renderer) {
                renderer.setMap(null);
            }
        };
    }, [renderer]);

    useEffect(() => {
        if (renderer && options.directions) {
            // The options prop is a fresh object every parent render; only push
            // to the renderer when something it draws from actually changed.
            // `map` must stay in the signature — the first non-null map is what
            // attaches the renderer.
            const strokeColor = options.options?.polylineOptions?.strokeColor;
            const last = lastAppliedRef.current;

            if (
                options.directions === last.directions &&
                options.map === last.map &&
                strokeColor === last.strokeColor
            ) {
                return;
            }

            renderer.setOptions(options);
            lastAppliedRef.current = { directions: options.directions, map: options.map, strokeColor };
        }
    }, [renderer, options]);

    return null;
}
